export default __webpack_public_path__ + "static/media/thumbnail-close.21f2de79.svg";